import { render, staticRenderFns } from "./CommunicationTable.vue?vue&type=template&id=23573f64"
import script from "./CommunicationTable.vue?vue&type=script&lang=js"
export * from "./CommunicationTable.vue?vue&type=script&lang=js"
import style0 from "./CommunicationTable.vue?vue&type=style&index=0&id=23573f64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports